export function toValidDate(value: unknown): Date | undefined {
  if (value == null) return undefined
  const d = value instanceof Date ? value : new Date(value as string | number)
  return Number.isNaN(d.getTime()) ? undefined : d
}
